import { ThunkDispatch as Dispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { alertConstants } from '../constants';

/**
 * Process related actions
 *
 * @type {Object}
 */
export const EditAlertAction = {

    /**
     * Get list of processes
     * @param unit
     *
     * @return {Promise.<Object>}
     */
    store: (alert: any | null) => {

        const success = (alert: any) => {

                return {
                    type: alertConstants.STORE_ALERT_SUCCESS,
                    alert: alert.alert,
                    unit: alert.unit,
                };

            },
        clear=()=>{
            return {
                type: alertConstants.CLEAR_ALERT_SUCCESS,
            };
        };


        return (dispatch: Dispatch<Record<string, unknown>, void, AnyAction>) => {

            dispatch(alert? success(alert): clear());
        };
    },

};
